import Callout from "components/callout/callout"
import useTargetStorage from "@/hooks/useTargetStorage"
import Section from "components/layout/section"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import AccessList from "components/access/AccessList"
import PageTitle from "features/navigation/pageTitle"
import SectionHeaderActions from "@/components/layout/sectionHeaderActions"
import useLayout from "@/hooks/useLayout"
import Button from "@/components/inputs/button"
import { ReactComponent as GroupAddIcon } from "assets/icons/group_add.svg"
import RightSidebar from "@/components/sidebar/right/RightSidebar"
import IconButton from "@/components/buttons/iconButton"
import { ReactComponent as RefreshIcon } from 'assets/icons/refresh.svg'
import useAccess from "@/hooks/useAccess"
import { AccessRole, DeviceSize, FormStatus } from "@/types"
import useStorages from "@/hooks/useStorages"
import { paramGuardStorage } from "@/utils/paramGuard"
import useWindowDimensions from "@/hooks/useWindowDimensions"
import { MainSheetHeaderActions } from "@/components/layout/layoutChrome"

const StorageAccessPage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const { targetStorageDocId: storageId } = useTargetStorage()

    const {
        openDialog
    } = useLayout()

    const {
        limitToRoles
    } = useAccess({ storageId: storageId || '' })

    // Only OWNER can grant access
    const canGrantAccess = limitToRoles([AccessRole.OWNER]);

    const { displayIfSize } = useWindowDimensions()

    const {
        storageInvitationsStatus,
        reloadAccessDocs
    } = useAccess({ storageId, refetchInterval: 30_000 })

    const {
        storage,
        storageStatus,
        isSharedAccessEnabled
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Redirect if shared access is disabled for this storage
    if (!isSharedAccessEnabled()) {
        navigate(`/storage`);
        return <></>;
    }

    // Render the JSX.
    return (
        <>
            <PageTitle title={t('titleStorageAccess')} />
            <MainSheetHeaderActions>
                {canGrantAccess && (
                    displayIfSize([DeviceSize.SM]) ?
                        <IconButton colorScheme="blue" className="visible md:invisible" onClick={() => openDialog('dialogGrantAccess')}><GroupAddIcon /></IconButton> :
                        <Button wideOnMobile type="submit" design="primary" onClick={() => openDialog('dialogGrantAccess')}><GroupAddIcon /><span>{t('buttonGrantAccess')}</span></Button>
                )}
                <IconButton
                    icon={<RefreshIcon className={storageInvitationsStatus === FormStatus.LOADING ? "animate-spin" : ""} />}
                    onClick={reloadAccessDocs}
                    disabled={storageInvitationsStatus === FormStatus.LOADING}
                />
            </MainSheetHeaderActions>
            <Section padX={false}>
                <AccessList storageId={safeStorageId} />
            </Section>
            <RightSidebar />
        </>
    )
}

export default StorageAccessPage

